// extracted by mini-css-extract-plugin
module.exports = {"container":"SignatureWrapper_container__2kIaj","canvas":"SignatureWrapper_canvas__3LdW4"};